import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { separateThousands } from '../utils/separate-thousands.utils';

@Directive({
  selector: '[lnsAccountBalance]'
})
export class AccountBalanceDirective implements OnChanges {
  @Input()
  set lnsAccountBalance(amount: any | undefined) {
    if (amount || amount === 0) {
      this.balanceAmount = amount;
    }
  }

  private balanceAmount = 0;

  constructor(private el: ElementRef) {}

  ngOnChanges(): void {
    this.setAmount(this.balanceAmount);
  }

  setAmount(amount: number | undefined): void {
    const price = amount ? (+amount).toFixed(2) : 0;
    const [fixed, decimal] = price.toString().split('.');
    this.el.nativeElement.innerHTML = `
      <p>${separateThousands(fixed, '.')}<span class="text-gray">,${
      decimal ? decimal : '00'
    }</span></p>
    `;
  }
}
